export function BinMgrDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.BIN_MGR + '/:param1/:param2')
        .setCustomActions({
            'get': {
                method: 'GET',
                isArray: true
            },
            'getInstancesForWatch': {
                method: 'GET',
                isArray: true,
                params: {param1: 'instancesForWatch'}
            },
            'getSpecificInstance': {
                method: 'GET',
                params: {param1: '@binMgrId'}
            },
            'createConnection': {
                method: 'POST',
                notifications: true
            },
            'updateConnection': {
                method: 'PUT',
                params: {param1: '@binMgrId'},
                notifications: true
            },
            'deleteConnection': {
                method: 'POST',
                params: {param1: 'delete'},
                notifications: true
            },
            'getBuilds': {
                method: 'GET',
                params: {param1: 'builds', param2: '@binMgrId'},
                notifications: true
            }, 'setBuildsForIndex': {
                method: 'POST',
                params: {param1: 'setBuildForIndex'},
                notifications: true
            },
            'getBuildsForWatch': {
                method: 'GET',
                params: {param1: 'buildsForWatch', param2: '@binMgrId'},
                notifications: true
            },
            'getRepositories': {
                method: 'GET',
                params: {param1: 'repos', param2: '@binMgrId'},
                notifications: true

            },
            'getRepositoriesForWatch': {
                method: 'GET',
                params: {param1: 'reposForWatch', param2: '@binMgrId'},
                notifications: true
            },
            'getAllRepositories': {
                method: 'GET',
                params: {param1: 'allRepos', param2: '@binMgrId'}
            },
            'setIndexedRepos': {
                method: 'POST',
                params: {param1: 'sendRepos'},
                notifications: true
            },
            'getRepositoriesStatus': {
                method: 'POST',
                path: XRAY_RESOURCE.REPO_INDEX_STATUS + '/:binMgrId',
                params: {binMgrId: '@binMgrId'}
            },
            'indexRepository': {
                method: 'POST',
                path: XRAY_RESOURCE.INDEX_BIN_MGR + '/:binMgrId',
                params: {binMgrId: '@binMgrId'},
                notifications: true
            },
            'refreshLicenseInfo': {
                method: 'POST',
                params: {param1: 'refreshLicense', param2: '@binMgrId'},
                notifications: true
            },
            'testConnection': {

                method: 'POST',
                params: {param1: 'testConnection'}
            },
            'checkConfiguration': {

                method: 'POST',
                params: {param1: 'checkConfigStatus'},

            }


        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/binmgr_dao.js